module.exports = __webpack_public_path__ + "media/activity-level/low-df5fd4d4.svg";